<p *ngIf="dateformat == 'today'"> {{ date | date: 'HH:mm'}} </p>
<p *ngIf="dateformat == 'currentyear'"> {{ date | date: 'dd-MMM'}} </p>
<p *ngIf="dateformat == 'pastyear'"> {{ date | date: 'MMM-yyy'}} </p>